import { IUtilisateurPreferencesWebServiceClient } from '@resources/resources';
import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";

@Injectable()
export class UtilisateurPreferencesServeurResultatsResolver implements Resolve<any> {

  constructor(private utilisateurPreferences : IUtilisateurPreferencesWebServiceClient) {
  }

  resolve() {
    return this.utilisateurPreferences.getUserPreferences('FILTRES', 'SERVEUR_RESULTATS');
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/utilisateur-preferences-serveur-resultats.resolver.ts